import {useEffect} from 'react';
import {useLocation, matchPath} from 'react-router-dom';

import * as NotificationConstants from '~/constants/NotificationConstants';

const OncePerSessionModals = new Set([
  NotificationConstants.EMBROIDERY_DESIGN_TIPS,
  NotificationConstants.EMBOSS_DESIGN_TIPS,
  NotificationConstants.DEBOSS_DESIGN_TIPS,
  NotificationConstants.LASER_ENGRAVING_DESIGN_TIPS
]);

export const PREFIX = 'SessionModals-';

const useSessionModals = notification => {
  const location = useLocation();

  const key = notification?.key;
  const force = notification?.payload?.forceOpen;

  useEffect(() => {
    return () => {
      if (OncePerSessionModals.has(key)) {
        sessionStorage?.setItem(PREFIX + key, true);
      }
    };
  }, [key]);

  const shouldRender = () => {
    const hasRendered =
      JSON.parse(sessionStorage?.getItem(PREFIX + key)) || false;

    const isAddedToCartOpened = matchPath(
      location.pathname,
      '/next/addedToCart'
    );

    const shouldRenderLater =
      isAddedToCartOpened && OncePerSessionModals.has(key);

    return force || (!shouldRenderLater && !hasRendered);
  };

  if (typeof sessionStorage === 'undefined') {
    return true;
  }
  return shouldRender();
};

export default useSessionModals;
